import { useState } from 'react'

export interface SlidePosition {
  slideDirection: 'left' | 'right' | undefined
  slideForward: () => void
  slideBackward: () => void
  pageIndex: number
  canGoBack: boolean
  canGoNext: boolean
  resetPages: () => void
}

const useSlidePosition = (maxIndex: number): SlidePosition => {
  const [pageIndex, setPageIndex] = useState(0)
  const [slideDirection, setSlideDirection] = useState<'left' | 'right' | undefined>(undefined)

  const canGoBack = pageIndex > 0
  const canGoNext = pageIndex < maxIndex

  const slideForward = () => {
    if (canGoNext) {
      setSlideDirection('right')
      setPageIndex((prev) => prev + 1)
    }
  }

  const slideBackward = () => {
    if (canGoBack) {
      setSlideDirection('left')
      setPageIndex((prev) => prev - 1)
    }
  }

  const resetPages = () => setPageIndex(0)

  return {
    slideDirection,
    slideForward,
    slideBackward,
    pageIndex,
    canGoBack,
    canGoNext,
    resetPages,
  }
}

export default useSlidePosition
